import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringRecommendationGroupSourceRow({
    item,
    selected = false,
    selectedItemId = "",
    selectable = false,
    onSelect,
    onOpenSource,
}) {
    const isSelected = selected || item?.id === selectedItemId

    return (
        <ListItemBox
            onClick={handleSelect}
            sx={{
                py: 0.75,
                px: 1,
                borderRadius: 1,
                border: "1px solid",
                borderColor: isSelected ? "primary.main" : "divider",
                alignItems: "flex-start",
                cursor: selectable ? "pointer" : "default",
            }}
        >
            <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
                    <Chip
                        size="small"
                        label={item?.sourceLabel || "Recommendation"}
                        color="primary"
                        variant="outlined"
                    />
                    <If value={isSelected}>
                        <Chip size="small" label="Selected" color="primary" />
                    </If>
                </Stack>
                <Typography variant="body2" color="text.primary">
                    {item?.changeLabel || "Recommendation"}
                </Typography>
                <If value={Boolean(item?.rationale)}>
                    <Typography variant="caption" color="text.secondary">
                        {item?.rationale}
                    </Typography>
                </If>
            </Stack>
            <If value={Boolean(item?.routeTo && onOpenSource)}>
                <Tooltip title="Open source">
                    <IconButton size="small" color="primary" onClick={handleOpenSource}>
                        <Iconify icon="mdi:open-in-new" width={16} />
                    </IconButton>
                </Tooltip>
            </If>
        </ListItemBox>
    )

    function handleSelect() {
        if (!selectable) return
        onSelect?.(item)
    }

    function handleOpenSource(event) {
        event.stopPropagation()
        onOpenSource?.(item)
    }
}
